class Overlay {
    constructor() {
        this.sources = {};
        this.isShown = false;
        this.element = document.getElementById('overlay');
    }

    show(source) {
        if (this.element) {
            this.sources[source] = true;
            if (!this.isShown) {
                this.element.classList.add('is-visible');
                this.isShown = true;
            }
        }
    }

    hide(source) {
        if (this.element) {
            this.sources[source] = false;
            if (this.isFree()) {
                this.element.classList.remove('is-visible');
                this.isShown = false;
            }
        }
    }

    isFree() {
        return Object.keys(this.sources).every((key) => this.sources[key] === false);
    }
}

const instance = new Overlay();
export default instance;
